var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConsultng(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 168.01 115.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-23,.cls-25,.cls-28,.cls-36,.cls-58{fill:none;}.cls-2,.cls-28{stroke:#fff;}.cls-2,.cls-23,.cls-25,.cls-36,.cls-51{stroke-miterlimit:10;}.cls-2{stroke-width:2px;}.cls-3{isolation:isolate;}.cls-4{fill:#193a5f;}.cls-5{fill:#bfc3ce;}.cls-31,.cls-51,.cls-6{fill:#fff;}.cls-7{fill:#dce8ff;}.cls-8{fill:#beccd5;}.cls-17,.cls-18,.cls-19,.cls-41,.cls-8{mix-blend-mode:multiply;}.cls-9{clip-path:url(#clip-path);}.cls-10{fill:#febfa7;}.cls-11{fill:#eba083;}.cls-12{fill:#222c2d;}.cls-13{fill:#75769a;}.cls-14{fill:#542f38;}.cls-15{fill:#5e952a;}.cls-16{fill:#00b06a;}.cls-17{fill:url(#linear-gradient);}.cls-18{fill:url(#linear-gradient-2);}.cls-19{fill:url(#linear-gradient-3);}.cls-20{fill:#abbe37;}.cls-21{fill:#ffa34d;}.cls-22{fill:#ff7c00;}.cls-23{stroke:#f49f34;}.cls-24{fill:#d7d5e0;}.cls-25{stroke:#222c2d;}.cls-26{fill:#dc1238;}.cls-27{fill:#586aff;}.cls-28,.cls-36,.cls-58{stroke-linecap:round;}.cls-28,.cls-58{stroke-linejoin:round;}.cls-28{stroke-width:0.75px;}.cls-29{fill:#1141a7;}.cls-30{fill:#fdf9f8;}.cls-31{font-size:2.65px;font-family:Roboto-Bold, Roboto;font-weight:700;}.cls-32{letter-spacing:-0.06em;}.cls-33{letter-spacing:-0.01em;}.cls-34{clip-path:url(#clip-path-2);}.cls-35{fill:#fda99b;}.cls-36{stroke:#2e353d;stroke-width:0.85px;}.cls-37{fill:#ffd71d;}.cls-38{letter-spacing:-0.03em;}.cls-39{clip-path:url(#clip-path-3);}.cls-40{fill:#26333b;}.cls-41{fill:#e8d4e5;}.cls-42{fill:#3d444d;}.cls-43{fill:#451b2d;}.cls-44{letter-spacing:-0.02em;}.cls-45{letter-spacing:-0.03em;}.cls-46{letter-spacing:0em;}.cls-47{letter-spacing:0em;}.cls-48{clip-path:url(#clip-path-4);}.cls-49{fill:#852926;}.cls-50{fill:#491b25;}.cls-51{stroke:#193a5f;}.cls-52{fill:#c9cdd8;}.cls-53{fill:#8a5843;}.cls-54{fill:#d3bbf6;}.cls-55{fill:#0e46ac;}.cls-56{fill:#8096e0;}.cls-57{fill:#6b7ce0;}.cls-58{stroke:#21295b;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 51.65,
    y: 12.26,
    width: 50.39,
    height: 89.08,
    transform: "translate(133.65 -20.05) rotate(90)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 171.38,
    y1: 161.71,
    x2: 174.06,
    y2: 161.71,
    gradientTransform: "translate(224.92 -80.38) rotate(83.37)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#91a8e0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 175.4,
    y1: 158.11,
    x2: 174.66,
    y2: 163.55,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 174.81,
    y1: 158.66,
    x2: 174.45,
    y2: 164.16,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 69.86,
    y: 3.69,
    width: 14.23,
    height: 14.23,
    rx: 5.51
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 98.04,
    y: 26.03,
    width: 14.29,
    height: 14.29,
    rx: 5.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 112.32,
    y: 50.49,
    width: 13.94,
    height: 13.94,
    rx: 5.39
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 28.98,
    y: 28.27,
    width: 95.74,
    height: 70.03,
    rx: 8.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M29,85.07h95.74a0,0,0,0,1,0,0v4.62a8.61,8.61,0,0,1-8.61,8.61H37.6A8.61,8.61,0,0,1,29,89.69V85.07A0,0,0,0,1,29,85.07Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 51.65,
    y: 12.26,
    width: 50.39,
    height: 89.08,
    transform: "translate(133.65 -20.05) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 51.65,
    y: 12.26,
    width: 50.39,
    height: 89.08,
    transform: "translate(133.65 -20.05) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M66.05,98.3a47.37,47.37,0,0,1-2.19,6.92h26a47.37,47.37,0,0,1-2.19-6.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M88.33,100.87c-.23-.79-.47-1.66-.68-2.57H66.05c-.21.91-.44,1.78-.68,2.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M94.69,105.09H59a2.36,2.36,0,0,0-2.36,2.36H97.05A2.36,2.36,0,0,0,94.69,105.09Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M65.22,76.68H88.75c.47-1.29.89-2.55,1.16-3.51a62.42,62.42,0,0,0,.24-7.32S84,63.08,83.54,62.7c-2-1.83-2.5-9-2.5-9H73.23s-.41,5.93-2.06,8.83c-.41.72-6.8,3.53-6.87,3.29l.13,6.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M81.85,59.34c-.52-2.59-.81-5.61-.81-5.61H73.23a53.87,53.87,0,0,1-1.68,8.21C74.39,62.26,79.81,61.89,81.85,59.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M83.23,51.8s-.08-2.59,2.09-2.5c1.39.07,1.48,1.34.37,3-.46.68-.53,2.24-1.1,2.73s-1.26-.34-1.46-.78A5.22,5.22,0,0,1,83.23,51.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M84.62,50.46c.41-.57.92-.19,1.14.34S85.47,52,85.47,52s.29-1-.12-1.23-1.42.47-1.07,1.15.85.74.53,1.09,0,.72-.5.88S84,53.79,84,53s0,0,0-.82A2.85,2.85,0,0,1,84.62,50.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M71,51.8s.09-2.59-2.08-2.5c-1.39.07-1.48,1.34-.37,3,.46.68.53,2.24,1.1,2.73s1.26-.34,1.46-.78A5.18,5.18,0,0,0,71,51.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M69.64,50.46c-.4-.57-.91-.19-1.13.34s.28,1.23.28,1.23-.28-1,.13-1.23S70.34,51.27,70,52s-.85.74-.53,1.09,0,.72.5.88.28-.13.31-.94,0,0,0-.82A2.79,2.79,0,0,0,69.64,50.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M85.21,46.74a24.63,24.63,0,0,1-.47,2.63c-.06.3-.12.64-.18,1A28.87,28.87,0,0,1,83,56.27a12.22,12.22,0,0,1-3.47,4,4.92,4.92,0,0,1-4.16,0c-1-.64-3.17-2.12-3.56-3.17A29.84,29.84,0,0,1,69.72,50c0-.36-.09-.67-.14-.95a24.91,24.91,0,0,1-.39-2.55c-.12-2.63,2.89-6.41,8.11-6.33C83.47,40.26,85.41,44.11,85.21,46.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M85.62,45.06c0,.08-.49,3.15-.67,3.64-.28.74-.49,1.27-.49,1.27l-.31-.69c-.56-1.28-.28-2.67-.29-4.07l-.6-2.63-.65-2.79C86.84,38.93,86.63,43.09,85.62,45.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M72,42.55h0l-1.34,2.71c-.22,1.25.22,2.45-.43,3.54l0,.06-.49.82-.32-1.16c-.14-.51-.46-3.08-.54-3.44,0-.12,0-.23-.07-.33-.34-1.94.88-4.59,2.59-4.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M85.37,42.15c-.2.5-2.11.43-2.11.43s-1.43,1.36-7.13,1.21a15.46,15.46,0,0,1-4.28-.55h0l-.34-.08-1.64-.38-.34-.08a1.44,1.44,0,0,1-.28-1c1-5.1,8.78-5.17,11-4.81C84.08,37.54,85.6,41.59,85.37,42.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M83.26,42.58a33.73,33.73,0,0,1-7.55,1.66c-2,.23-3.44.79-4.2-1.08,0,0,.47-2.37,4.07-2.62S83.26,42.58,83.26,42.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M61.58,109.71H95.22c-.45-5.09-2.24-18.54-2.89-25-.58-5.87-.81-19-.81-19l-7.68-2.84s-.94,4.34-6.4,4.34c-6.25,0-7-4-7-4-3,.84-7.42,2.47-7.42,2.47s.32,18.23-.87,30.45C61.72,100.24,61.61,106.18,61.58,109.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M78.53,46.93a11,11,0,0,1,2.56-.4,1.53,1.53,0,0,1,1.19.8.58.58,0,0,1,0,.43,3.12,3.12,0,0,0-.91-.36c-.33,0-1.18-.06-2-.09C78.91,47.3,78.45,47.12,78.53,46.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M75.88,46.93a10.93,10.93,0,0,0-2.56-.4,1.5,1.5,0,0,0-1.18.8.57.57,0,0,0,0,.43A3.12,3.12,0,0,1,73,47.4c.33,0,1.19-.06,2-.09C75.51,47.3,76,47.12,75.88,46.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M78.74,55.25a1.56,1.56,0,0,1-1.46,1,2.47,2.47,0,0,1-.88-.2c-.59-.31-.86-.84-.76-.81A9.77,9.77,0,0,0,78.74,55.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M73.62,48.9a.61.61,0,0,0,.61.62.62.62,0,0,0,.62-.62.61.61,0,0,0-.62-.61A.61.61,0,0,0,73.62,48.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M79.61,48.9a.61.61,0,0,0,.61.62.62.62,0,0,0,.62-.62.61.61,0,0,0-.62-.61A.61.61,0,0,0,79.61,48.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M77.38,53.86a1.67,1.67,0,0,1-1.11-.38,1,1,0,0,1-.28-.8A5.31,5.31,0,0,1,76.54,51a10.39,10.39,0,0,0,.6-1.66.15.15,0,0,1,.17-.12.16.16,0,0,1,.12.18,10.34,10.34,0,0,1-.62,1.71,5.4,5.4,0,0,0-.53,1.58.69.69,0,0,0,.2.57,1.43,1.43,0,0,0,1,.29.15.15,0,1,1,0,.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M87.58,110.83l-.07-.6-5.1.69,5.06-1-.07-.62c-1.63.4-4.63,1-5,1.19-.58.25-1,.38-1,.61a.44.44,0,0,0,.64.39C82.28,111.4,85.57,111,87.58,110.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M82.1,110.62c.11-.11,3.39-1,5.27-1.56l-.07-.58c-2.24.89-6,2.14-6.09,2.27s-.09.75.23.76a1.28,1.28,0,0,0,.73-.26A.41.41,0,0,1,82.1,110.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M82.1,110.62c.11-.11,3.39-1,5.27-1.56l-.07-.58c-2.24.89-6,2.14-6.09,2.27s-.09.75.23.76a1.28,1.28,0,0,0,.73-.26A.41.41,0,0,1,82.1,110.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M87.76,112.35c-2.05-.21-5.45-.31-5.6-.4a.42.42,0,0,1-.08-.63,1.25,1.25,0,0,0-.76-.08c-.31.08-.24.63,0,.79s4,.43,6.55.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M87.76,112.35c-2.05-.21-5.45-.31-5.6-.4a.42.42,0,0,1-.08-.63,1.25,1.25,0,0,0-.76-.08c-.31.08-.24.63,0,.79s4,.43,6.55.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M87.69,111.72l-5.17-.07,5.13-.26-.07-.61c-2,.13-5.31.42-5.55.39-.41,0-.57.18-.53.48s.52.3,1.16.45c.34.09,3.43.11,5.1.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M87.69,111.72l-5.17-.07,5.13-.26-.07-.61c-2,.13-5.31.42-5.55.39-.41,0-.57.18-.53.48s.52.3,1.16.45c.34.09,3.43.11,5.1.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M87.76,112.35l-.58,0,.58,0-.07-.61-5.17-.07,5.13-.26-.07-.61c-1.93.13-5.07.4-5.5.39a.41.41,0,0,1,0-.55c.11-.11,3.39-1,5.27-1.56l-.07-.58c-2.24.89-6,2.14-6.09,2.27a.62.62,0,0,0,0,.58.59.59,0,0,0,.08.7c.13.11,4,.43,6.55.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M73.59,111.28c-.24-.49-.49-.64-1.23-.61-.5,0-.47,1.2-.22,1.91.3.88.71,1.65,1.45,1.4S74,112.06,73.59,111.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M80.24,109.27a7.54,7.54,0,0,0-1.69.27,17.05,17.05,0,0,0-1.88.17c-1.26.32-2.53.56-3.8.86-.17,0-.68.06-.51.1a2.92,2.92,0,0,1,1.42,2.38,1.71,1.71,0,0,1-.19.93,13.07,13.07,0,0,0,2-.06c.65-.09,1.29,0,1.94,0s1.42-.27,2.17-.28a2.07,2.07,0,0,0,1.61-.48,2.3,2.3,0,0,0,.74-1.75A2.26,2.26,0,0,0,80.24,109.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M67.25,114.71c.27-.77-.81-1.14-1.62-1s-.82,1.33-.12,1.74A1.2,1.2,0,0,0,67.25,114.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M67.25,114.48c.12-.44-.62-1-1.43-.85a.83.83,0,0,0-.31,1.55A1.18,1.18,0,0,0,67.25,114.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M68.68,114c.41-1-.93-1.32-2-1.14a1.17,1.17,0,0,0-.3,2.13A1.71,1.71,0,0,0,68.68,114Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M68.71,113.72c.18-.55-.72-1.11-1.75-.93s-1.37,1.48-.52,1.92A1.69,1.69,0,0,0,68.71,113.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M71,113.83c-.12-1.17-1.21-1.35-2.36-1.15a1.31,1.31,0,0,0-.33,2.39C69.54,115.73,71,114.67,71,113.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M70.82,113.64c0-.65-.81-1.24-2-1s-1.53,1.66-.58,2.15A1.72,1.72,0,0,0,70.82,113.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M72.62,113.62c-.12-1.24-1.27-1.43-2.49-1.21a1.39,1.39,0,0,0-.35,2.52C71.13,115.63,72.71,114.51,72.62,113.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M72.48,113.43c0-.69-.84-1.31-2.06-1.1s-1.62,1.75-.61,2.27A1.8,1.8,0,0,0,72.48,113.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M83.3,105.09c-.9.33-3.28-.49-4.19-.57s-2.79,1.31-3.61,2.21-2,1.85-2,3.21c0,.77.61.35,1-.11s1.24-1.38,1.57-1.66a7,7,0,0,1,1.57-1,26.33,26.33,0,0,1-1.85,1.94,6.39,6.39,0,0,0-1.29,2,.54.54,0,0,0,.87.46c.51-.28,1.34-1.75,1.85-2.08s1.66-.87,1.66-.87a16.32,16.32,0,0,1-1.57,1.75c-.6.51-1.66,1.52-1.61,1.85s.09.51,1,.14a9.28,9.28,0,0,0,2.08-1.48c.46-.32,1.34-.83,1.34-.83a9.41,9.41,0,0,1-1.85,1.84c-.69.37-1.38.74-1.2,1.07s1.53-.28,2.73-.74a42.67,42.67,0,0,0,5.95-2.82c1.39-.92,9.93-3.42,12-4.85s2.22-1.71,2.31-2.86-5.77-5-5.77-5a70.44,70.44,0,0,0-6.33,5A36.21,36.21,0,0,1,83.3,105.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M91.51,65.63s-.56,13.2-.75,16.73S94.3,93.52,94.3,94.45s-3.91,3.72-6.51,6.14-4.85,4.61-4.85,4.61,2.62,2.64,3.18,4.32a106.16,106.16,0,0,0,9.85-4.1c4.09-2,6.88-3.71,7.63-5.57s.18-8.93-.93-13.58a56.47,56.47,0,0,0-5.4-14.88A14.62,14.62,0,0,0,91.51,65.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M94.3,94.45a6.81,6.81,0,0,1,5.58.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "68.25 101.47 71.1 107.27 72.3 106.07 70.33 98.84 68.25 101.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M71.43,105.62c.29.69,0,1.3.07,1.94s.4,1.66,1.82,3.82S76,115,76.84,115.25a7.82,7.82,0,0,0,1.28.34l-6.45-11.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M58.62,93.15c2.41.11,6.89.44,8.43.44a3.15,3.15,0,0,1,3.26,2.1c.72,1.57,2.21,3.48,2.54,5a19.51,19.51,0,0,1-.11,6.24c-.33,1.1-1.53.88-1.64.33s.11-2.63.11-3.39a7.94,7.94,0,0,0-1.1-2.52s.11,3.07-.55,3.61-1.09-.44-1.2-.87c0,0-1.53.33-2-.77a3.48,3.48,0,0,1-1.42-2c-.33-1.31-.66-2.3-.66-2.3s-3.72,1.53-6.13,1.42-4.27-.87-4.93-2.73S58.62,93.15,58.62,93.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M62.87,65.81C59,68.42,55.43,73.07,54.5,77.72s-4.61,15.33-4.81,18.14c-.4,5.47,1.86,6,3.9,6.14s5.4-1,7.07-1.38,3-.75,3-.75a5.71,5.71,0,0,1,0-2.79c.59-1.82,2.08-3.49,3.38-3.49a15.37,15.37,0,0,0-4.37-1.65c-1.1-.26-2.32-.46-2.32-.46s2.88-3.91,4.37-6.33S62.87,65.81,62.87,65.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M53.41,96.61a11.84,11.84,0,0,1,7-5.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M92.58,90s-1.16-6.43.16-11.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M62.6,88.15a30.53,30.53,0,0,0,.66-8.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M85.25,104.29s.9,0,2.14,2.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M64.24,92.59a4.59,4.59,0,0,0-2.8,4.78"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-26",
    cx: 92.09,
    cy: 76.25,
    r: 3.66
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-27",
    cx: 81.95,
    cy: 76.25,
    r: 3.66
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-27",
    cx: 72.55,
    cy: 76.25,
    r: 3.66
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-27",
    cx: 63.15,
    cy: 76.25,
    r: 3.66
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 61.07,
    y: 75.45,
    width: 0.96,
    height: 1.6
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "62.03 77.09 63.8 77.91 63.8 74.59 62.03 75.41 62.03 77.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M65,74.86a2,2,0,0,1,0,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M64.39,75.51a1.06,1.06,0,0,1,0,1.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M74.43,75.89a1.8,1.8,0,0,1-1.8,1.8h0a1.8,1.8,0,0,1-1.8-1.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M72.63,76.93h0a1,1,0,0,1-1-1V75a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1v1A1,1,0,0,1,72.63,76.93Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-28",
    x1: 72.63,
    y1: 77.86,
    x2: 72.63,
    y2: 78.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 79.91,
    y: 75.08,
    width: 2.84,
    height: 2.29,
    rx: 1.15
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "83.95 77.67 82.75 76.94 82.75 75.56 83.95 74.84 83.95 77.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M81.08,76a.29.29,0,1,1-.29-.28A.29.29,0,0,1,81.08,76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M93.64,75.54H90.82a1.07,1.07,0,0,0-1.06,1.08v.06a.29.29,0,0,0,.29.29H91a.3.3,0,0,0,.28-.22.69.69,0,0,1,.56-.5h.88a.69.69,0,0,1,.56.5.3.3,0,0,0,.28.22h.9a.29.29,0,0,0,.29-.29v-.06A1.07,1.07,0,0,0,93.64,75.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M122.67,1.34H67.21a2.75,2.75,0,0,0-2.75,2.75V18.16a2.76,2.76,0,0,0,2.75,2.76h2.25v5l8-5h45.21a2.77,2.77,0,0,0,2.76-2.76V4.09A2.76,2.76,0,0,0,122.67,1.34Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-30",
    cx: 116.66,
    cy: 6.82,
    r: 1.22
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-31",
    transform: "translate(88.59 7.9)"
  }, "CRE", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-32",
    x: 4.92,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    x: 6.55,
    y: 0
  }, "TIVE DIRE"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-33",
    x: 18.52,
    y: 0
  }, "CT"), /*#__PURE__*/React.createElement("tspan", {
    x: 21.82,
    y: 0
  }, "OR")), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 89.22,
    y: 9.88,
    width: 31.63,
    height: 0.95
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 89.22,
    y: 12.5,
    width: 31.63,
    height: 0.95
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 89.22,
    y: 15.11,
    width: 14.51,
    height: 0.95
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-34"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 69.86,
    y: 3.69,
    width: 14.23,
    height: 14.23
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M72.82,19.62H81c.13-.37.25-.72.32-1a21.56,21.56,0,0,0,.09-2.51S79.3,15.16,79.16,15c-.7-.63-.86-3.39-.86-3.39H75.61a10.74,10.74,0,0,1-.7,3.34,9.28,9.28,0,0,1-2.36,1.13l0,2.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M78.53,13.43a14.33,14.33,0,0,1-.23-1.79H75.61a13.12,13.12,0,0,1-.46,2.77C76.12,14.52,77.83,14.31,78.53,13.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M79.05,11s0-.89.72-.86c.47,0,.5.46.13,1-.16.23-.19.77-.38.94s-.43-.12-.5-.27A1.72,1.72,0,0,1,79.05,11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M79.53,10.52c.14-.2.31-.07.39.12s-.1.42-.1.42.1-.34,0-.42-.49.16-.37.39.29.26.18.37,0,.25-.17.31-.1-.05-.11-.33a.88.88,0,0,1,0-.28A1,1,0,0,1,79.53,10.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M74.86,11s0-.89-.72-.86c-.47,0-.5.46-.12,1,.16.23.18.77.38.94s.43-.12.5-.27A1.82,1.82,0,0,0,74.86,11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M74.38,10.52c-.14-.2-.31-.07-.39.12s.1.42.1.42-.1-.34,0-.42.49.16.37.39-.29.26-.18.37,0,.25.17.31.1-.05.11-.33a.88.88,0,0,0,0-.28A1,1,0,0,0,74.38,10.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M79.73,9.24a7.58,7.58,0,0,1-.16.9c0,.11,0,.22-.06.36a9.89,9.89,0,0,1-.53,2,4.18,4.18,0,0,1-1.19,1.36,1.67,1.67,0,0,1-1.43,0,3.51,3.51,0,0,1-1.23-1.08,10.79,10.79,0,0,1-.72-2.43c0-.12,0-.23,0-.32a6.68,6.68,0,0,1-.13-.88A2.52,2.52,0,0,1,77,7C79.13,7,79.8,8.34,79.73,9.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M79.87,8.66s-.17,1.09-.23,1.25l-.17.44-.1-.24a3.24,3.24,0,0,1-.1-1.39l-.21-.91.3-.26C80,7.65,80,8,79.87,8.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M75.18,7.8h0l-.46.92c-.07.43.08.85-.15,1.22v0l-.17.28s0-.16-.11-.4-.16-1-.18-1.18l0-.11c-.11-.66,0-.94.6-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M79.78,7.66c-.06.18-.72.15-.72.15s-.49.47-2.45.42A5.22,5.22,0,0,1,75.14,8h0L75,8l-.56-.13-.11,0a6.1,6.1,0,0,1,.23-.63c.73-1.39,2.53-1.13,3.29-1C79.19,6.43,79.86,7.47,79.78,7.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M77.05,10.53c0,.48-.43.89-.35,1.14s.28.25.28.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M78.12,10.09c0,.13-.07.24-.17.24s-.17-.11-.17-.24.08-.23.17-.23S78.12,10,78.12,10.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M76.28,10.09c0,.13-.08.24-.17.24s-.17-.11-.17-.24.07-.23.17-.23S76.28,10,76.28,10.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M77.67,9.41c-.23.07-.17.28,0,.24a2.21,2.21,0,0,1,.77,0c.26,0,0-.14-.18-.21A1.13,1.13,0,0,0,77.67,9.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M76.44,9.45c.22.09.14.3-.06.23a2.64,2.64,0,0,0-.77-.08c-.26,0,0-.14.2-.18A1.12,1.12,0,0,1,76.44,9.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M76.45,12.29a1.37,1.37,0,0,0,.65.13,1.22,1.22,0,0,0,.72-.16s-.25.61-.8.51A.79.79,0,0,1,76.45,12.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M79.06,7.81a5,5,0,0,1-2.43.88c-.69.07-.42-.56-.42-.56S75.29,8.66,75,8c0,0,.17-.81,1.4-.9A5.73,5.73,0,0,1,79.06,7.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M72.1,19.62H82c-.07-1.86-.1-3.68-.1-3.68l-2.64-.87a2.08,2.08,0,0,1-2.2,1.49c-2.15,0-2.41-1.36-2.41-1.36-1,.29-2.55.85-2.55.85S72.13,17.57,72.1,19.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M84.69,19.62a18.19,18.19,0,0,0-.81-1.7,5,5,0,0,0-2-2s-.08,2-.16,3.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M72.67,19.62c-.22-1.74-.57-3.57-.57-3.57a6.34,6.34,0,0,0-2.79,3.57Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 69.86,
    y: 3.69,
    width: 14.23,
    height: 14.23,
    rx: 5.51
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M150.91,23.41H95.45a2.75,2.75,0,0,0-2.75,2.75V40.23A2.76,2.76,0,0,0,95.45,43H97.7v5l8-5h45.21a2.77,2.77,0,0,0,2.76-2.76V26.16A2.76,2.76,0,0,0,150.91,23.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M146.38,28.85a1.22,1.22,0,1,1-1.22-1.22A1.22,1.22,0,0,1,146.38,28.85Z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-31",
    transform: "translate(117.42 29.97)"
  }, "PROJE", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-33",
    x: 8.2,
    y: 0
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-38",
    x: 9.9,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    x: 11.46,
    y: 0,
    xmlSpace: "preserve"
  }, " MANAGER")), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 117.46,
    y: 31.95,
    width: 32.51,
    height: 0.95
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 117.46,
    y: 34.56,
    width: 32.51,
    height: 0.95
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 117.46,
    y: 37.18,
    width: 14.51,
    height: 0.95
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-39"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 98.04,
    y: 26.03,
    width: 14.29,
    height: 14.29
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M101.43,41.4h7.37c.18-.34.35-.67.47-.93a17.34,17.34,0,0,0,.3-2.09s-2-.86-2.18-1c-.69-.59-.76-3.38-.76-3.38h-2.94a10.09,10.09,0,0,1-.6,3.34,9.29,9.29,0,0,1-2.28,1l.25,1.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M106.81,35.88a14.05,14.05,0,0,1-.18-1.86h-2.94a13.4,13.4,0,0,1-.38,2.8C104.31,36.93,106.06,36.73,106.81,35.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M100.28,43h10c-.11-2.13-.15-4.62-.15-4.62l-2.65-.87a2.09,2.09,0,0,1-2.2,1.5c-2.16,0-2.42-1.37-2.42-1.37-1,.29-2.56.85-2.56.85S100.32,40.45,100.28,43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M106.88,33.45s0-.83.66-.81c.44,0,.48.42.13,1-.14.22-.16.71-.34.88s-.4-.11-.47-.25A1.66,1.66,0,0,1,106.88,33.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M107.29,33.07c.24-.14.52-.11.35.16s-.27.35-.26.65a.25.25,0,0,1-.23.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M103.14,33.45s0-.83-.65-.81c-.44,0-.48.42-.13,1,.14.22.16.71.34.88s.4-.11.47-.25A1.62,1.62,0,0,0,103.14,33.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M102.81,33.07c-.24-.14-.51-.11-.35.16s.27.35.26.65a.25.25,0,0,0,.23.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M107.59,31.42a8.07,8.07,0,0,1-.14.84c0,.1,0,.21-.06.34-.14,1-.32,2.34-.4,2.55a3.6,3.6,0,0,1-1.18,1.07,2,2,0,0,1-1.52,0,3.7,3.7,0,0,1-1.23-1c-.08-.21-.27-1.6-.41-2.61,0-.12,0-.22-.05-.3a8.29,8.29,0,0,1-.14-.82A2.36,2.36,0,0,1,105,29.36C107,29.36,107.64,30.58,107.59,31.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M103.14,30.79a12.29,12.29,0,0,1,3.35-.25l.54-.35a4.78,4.78,0,0,0-2.18-.53A2,2,0,0,0,103.14,30.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M104.61,31.65l-.81,0a.5.5,0,0,0-.38.26.53.53,0,0,0,0,.22s.22-.2.3-.2.52,0,.77,0S104.64,31.71,104.61,31.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M105.41,31.65l.81,0a.48.48,0,0,1,.38.26.52.52,0,0,1,0,.22s-.22-.2-.31-.2-.51,0-.77,0S105.39,31.71,105.41,31.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M105.55,34.7a.5.5,0,0,1-.47.32.68.68,0,0,1-.29-.06c-.18-.1-.27-.27-.24-.26A3.05,3.05,0,0,0,105.55,34.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M107.51,32.05c0,.07-.05.14-.07.2h0c0,.1,0,.21-.06.34s-.07.5-.11.77l-.28.34a10.93,10.93,0,0,0,.26-1.47h0a3.25,3.25,0,0,1-.3-1.3l-.1-.67-.45,0a9.41,9.41,0,0,0-1.88,0,2.05,2.05,0,0,0-1.39.46,4.2,4.2,0,0,1-.35,1.36v.05a9.2,9.2,0,0,0,.22,1.42l-.23-.25c0-.29-.08-.57-.11-.83,0,0,0-.07,0-.1h0s0-.16-.11-.37-.16-1-.19-1.1a.43.43,0,0,0,0-.11c-.1-.51.11-2.42,3.06-2.19h.1a2.49,2.49,0,0,1,1.42.59l.33.58c.56.08.61.4.49,1C107.7,30.91,107.57,31.89,107.51,32.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M103.82,32.45a.2.2,0,1,0,.2-.2A.2.2,0,0,0,103.82,32.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M105.74,32.45a.2.2,0,1,0,.2-.2A.2.2,0,0,0,105.74,32.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M105,32.7c-.08.38-.35.79-.36,1.06s.42.33.42.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M113.27,43a16.62,16.62,0,0,0-1.16-2.63,5,5,0,0,0-2-2s-.11,2.83-.2,4.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M101,43c-.18-2-.67-4.51-.67-4.51a6.43,6.43,0,0,0-2.92,4.06l-.11.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M104.61,31.65l-.81,0a.5.5,0,0,0-.38.26.53.53,0,0,0,0,.22s.22-.2.3-.2.52,0,.77,0S104.64,31.71,104.61,31.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M105.41,31.65l.81,0a.48.48,0,0,1,.38.26.52.52,0,0,1,0,.22s-.22-.2-.31-.2-.51,0-.77,0S105.39,31.71,105.41,31.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M105.55,34.7a.5.5,0,0,1-.47.32.68.68,0,0,1-.29-.06c-.18-.1-.27-.27-.24-.26A3.05,3.05,0,0,0,105.55,34.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M103.82,32.45a.2.2,0,1,0,.2-.2A.2.2,0,0,0,103.82,32.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M105.74,32.45a.2.2,0,1,0,.2-.2A.2.2,0,0,0,105.74,32.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M105,34.18a.57.57,0,0,1-.39-.13.38.38,0,0,1-.1-.29,1.89,1.89,0,0,1,.18-.56,3.63,3.63,0,0,0,.19-.52l.17,0a3.14,3.14,0,0,1-.2.56,1.79,1.79,0,0,0-.17.49.25.25,0,0,0,0,.15A.45.45,0,0,0,105,34v.18Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 98.04,
    y: 26.03,
    width: 14.29,
    height: 14.29,
    rx: 5.53
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M165.26,47.53H109.8A2.76,2.76,0,0,0,107,50.28V64.35a2.76,2.76,0,0,0,2.76,2.76H112v5l8-5h45.21A2.75,2.75,0,0,0,168,64.35V50.28A2.75,2.75,0,0,0,165.26,47.53Z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-31",
    transform: "translate(131.18 54.09)"
  }, "A", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-44",
    x: 1.78,
    y: 0
  }, "R"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-45",
    x: 3.41,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-46",
    x: 4.97,
    y: 0,
    xmlSpace: "preserve"
  }, " DIRE"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-33",
    x: 11.31,
    y: 0
  }, "CT"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-47",
    x: 14.61,
    y: 0
  }, "OR")), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 131.21,
    y: 56.07,
    width: 31.63,
    height: 0.95
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 131.21,
    y: 58.69,
    width: 31.63,
    height: 0.95
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 131.21,
    y: 61.3,
    width: 14.51,
    height: 0.95
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 112.32,
    y: 50.49,
    width: 13.94,
    height: 13.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M116.25,60.53a4.41,4.41,0,0,0,.44,2.28,9.94,9.94,0,0,1,2.15-.5,17.5,17.5,0,0,1,3.6.23,22.24,22.24,0,0,0-.17-5.21c-.44-2-1.27-2.82-2.23-3.14a2.79,2.79,0,0,0-2.08.41S116.19,59.37,116.25,60.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M117.18,65.29l4.34-.07c.11-.15.1-2.07.17-2.19a7,7,0,0,0,.27-1s-1.21-.43-1.29-.49c-.41-.3-.41-1.83-.41-1.83h-1.91a4.65,4.65,0,0,1-.31,1.81,5.61,5.61,0,0,1-1.34.51l.23.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M120.34,60.74a7.42,7.42,0,0,1-.08-1h-1.91a6,6,0,0,1-.18,1.53A3.23,3.23,0,0,0,120.34,60.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M115.84,65.78h7.1c-.09-1.57-.12-3.61-.12-3.61l-1.3-.43a2.26,2.26,0,0,1-2.18,2.79c-2.18.14-2.18-2.69-2.18-2.69-.74.2-1.3.41-1.3.41S115.88,63.85,115.84,65.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M125.16,65.78a13,13,0,0,0-.93-2.2,3.53,3.53,0,0,0-1.41-1.41s-.1,2.4-.16,3.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M116.36,65.78a35.6,35.6,0,0,0-.5-3.53,4.54,4.54,0,0,0-2.07,2.87c0,.18-.09.41-.16.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M121.38,58.23a.77.77,0,0,1,0,.15,3,3,0,0,1-.34,1.06,3.75,3.75,0,0,1-1.4,1.23,1,1,0,0,1-.56,0,3.28,3.28,0,0,1-1.62-1.48,4.58,4.58,0,0,1-.3-1.52c0-.58-.08-1.34,0-1.79a1.28,1.28,0,0,1,.84-1.24c1.26-.47,3.49.58,3.49,1.07A19.13,19.13,0,0,1,121.38,58.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M118.88,56.57a2.94,2.94,0,0,0-.78-.14.48.48,0,0,0-.37.25s.19-.07.28-.07a5.36,5.36,0,0,0,.63.06A.34.34,0,0,0,118.88,56.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M119.51,56.57a2.84,2.84,0,0,1,.78-.14.48.48,0,0,1,.37.25s-.2-.07-.28-.07a5.58,5.58,0,0,1-.64.06A.31.31,0,0,1,119.51,56.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M117.62,60.13a12.63,12.63,0,0,1-.37-1.81c0-.48,0-1.17,0-1.56a1.25,1.25,0,0,1,.2-.69c0-.51.28-.91.33-1.16s.5-1.35.21-1.49l-.16-.05a1.16,1.16,0,0,0-1.25.85,14.69,14.69,0,0,0-.43,4.15c0,.45,0,1.36.08,2.16A8.26,8.26,0,0,0,117.62,60.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M122.47,59.32c0,.3,0,.57,0,.78s0,1.58,0,1.65c-.3.88-2.21-.41-2.21-.41a5.86,5.86,0,0,0,1-3.59c0-1-.1-1.42-.41-1.72-.08-.08-.23-.83-.32-.9s0,.89,0,.84c-.47-.26-2.11.13-2.53,0-.27-.08-.33-1.08-.33-1.08-.3-.73.16-1,.22-1.37s.63-.58,1.31-.59a4.32,4.32,0,0,1,.94.08A2.55,2.55,0,0,1,122,54.88,23.59,23.59,0,0,1,122.47,59.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M119.75,59.14a.49.49,0,0,1-.45.31.64.64,0,0,1-.28-.06c-.18-.1-.27-.26-.24-.25A3.5,3.5,0,0,0,119.75,59.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M118.12,57.19a.19.19,0,0,0,.19.19.2.2,0,0,0,.19-.19.2.2,0,0,0-.19-.2A.19.19,0,0,0,118.12,57.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M120,57.19a.2.2,0,0,0,.19.19.2.2,0,1,0-.19-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M119.25,58.73a.59.59,0,0,1-.38-.12.32.32,0,0,1-.1-.25,1.48,1.48,0,0,1,.18-.49,2.19,2.19,0,0,0,.18-.46.09.09,0,0,1,.11-.06.08.08,0,0,1,.06.09,2.92,2.92,0,0,1-.19.49,1.25,1.25,0,0,0-.16.44.12.12,0,0,0,0,.13.37.37,0,0,0,.27.07.09.09,0,0,1,.09.08.08.08,0,0,1-.08.08Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 112.32,
    y: 50.49,
    width: 13.94,
    height: 13.94,
    rx: 5.39
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M153.41,53a1.22,1.22,0,1,1-1.22-1.22A1.22,1.22,0,0,1,153.41,53Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 23.57,
    y: 0.5,
    width: 33.72,
    height: 47.12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 28.77,
    y: 21.88,
    width: 1.16,
    height: 1.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 31.53,
    y: 21.88,
    width: 18.21,
    height: 1.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 28.77,
    y: 24.88,
    width: 1.16,
    height: 1.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 31.53,
    y: 24.88,
    width: 18.21,
    height: 1.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 28.77,
    y: 27.88,
    width: 1.16,
    height: 1.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 31.53,
    y: 27.88,
    width: 20.99,
    height: 1.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 31.53,
    y: 30.87,
    width: 9.8,
    height: 1.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 28.77,
    y: 36.55,
    width: 9.8,
    height: 1.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 32.4,
    y: 15.91,
    width: 16,
    height: 2.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 28.77,
    y: 39.54,
    width: 20.62,
    height: 1.22
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M44.66,13.86A4.5,4.5,0,0,0,40.84,11h-.69a4.52,4.52,0,0,0-3.82,2.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M42.52,7.63c0,1.19-.9,2.56-2,2.56s-2-1.37-2-2.56a2,2,0,1,1,4.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M33.15,32.2a6.7,6.7,0,1,0,4.3,8.44A6.7,6.7,0,0,0,33.15,32.2Zm-3.8,11.67a5.57,5.57,0,1,1,7-3.58A5.57,5.57,0,0,1,29.35,43.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M26.38,52.21h0a.52.52,0,0,1-.33-.66l2.35-7.07,1,.32L27,51.87A.53.53,0,0,1,26.38,52.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M25.93,53.59h0a.8.8,0,0,1-.51-1l1.91-5.77,1.5.48-1.91,5.77A.79.79,0,0,1,25.93,53.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1.12,62a10.41,10.41,0,0,0,.26,5.46c.18.63,2.82,9.2,3.88,9.93l.61-2.53L5.1,71.34c-.59-2.66-1.18-5.84-1.18-5.84s.71-4.31,1-4.9S1.12,62,1.12,62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M2.8,55.3c-.65.46-2.45,8-2.45,8s.45.88,2.45.92c2.37,0,2.28-1,2.28-1s2-5.37,1.56-6.76S2.8,55.3,2.8,55.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M9.88,55.41c-.15-.63.28-2.35.35-4l-3.75.69S5.4,55.21,5.27,55.41C6.46,56,9.51,55.41,9.88,55.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M10.57,45.45c1.18.5,1.89,3,1.86,3.26s-.11.35,0,.64a4,4,0,0,1,.3.67c.05.15-.49.49-.39.69s-.22.33-.21.54-.17,1.44-.56,1.68a3.67,3.67,0,0,1-2.5-.27c-.83-.38-.78-1.82-.78-1.82s-5.22-3.72-.14-5.11A5.42,5.42,0,0,1,10.57,45.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M11.82,46.41c-.44.77-1.17.59-1.52,1.27a3.55,3.55,0,0,0-.08,1.58s-.26.43-.33.09c-.14-.67-.4-1.08-.78-1-.76.23-.54,1.25.11,1.71s.08.73-.68,1.9c-.32.5-2.08.41-2.08.41a6.54,6.54,0,0,0-.83-2c-.84-1.52-1.45-2-1.14-2.85C5,46,5.74,46.4,6.12,45.91c0,0,.42-1.95,2.1-1.95a4.68,4.68,0,0,0,1.92-.18c.7-.19,1.22-.26,1.53.14A2.63,2.63,0,0,1,11.82,46.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M11.1,105.37a4.16,4.16,0,0,1,1.53-.37,4.67,4.67,0,0,1,1.63.37c.36.11,3.93,1.53,4,1.92s-.7.5-2,.5-3,.06-3.81,0a4.38,4.38,0,0,1-1.26-.22S10.52,107,11.1,105.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M.25,105.37A4.16,4.16,0,0,1,1.78,105a4.67,4.67,0,0,1,1.63.37c.36.11,2.86,1.53,2.91,1.92s-.71.5-2,.5-1.9.06-2.74,0a4.38,4.38,0,0,1-1.26-.22S-.33,107,.25,105.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M3.25,72c0,2.4-.5,7.56-.45,11.57s-.07,7.64-.07,7.64c-1,6.19-2.73,14.4-2.73,14.4s2.31.77,3.6,0c0,0,1.91-7.13,3.25-11A40.86,40.86,0,0,0,9.2,83.47c.51-5.07,1.32-10.83,1.32-10.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M5.49,71.87c.11,1.49,2.31,11.15,2.9,13a33.63,33.63,0,0,1,1.22,6.3c-.12.31.67,7.9.91,10.92s.58,3.23.58,3.23a5,5,0,0,0,3.16,0s.32-11.91.37-15.77S14,77.62,13.79,75c-.23-3.4-.23-5.81-.23-5.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M5.65,53.74a2.83,2.83,0,0,0,2.13.67A5.68,5.68,0,0,0,10,53.72l3.23.85s.42,4,.55,7.62,0,13,0,13-1.07-.15-4.23.78c-4,1.17-5.16-.3-6.58-1.14,0,0,.18-6,0-8s-.4-5.52-.44-7.21a19.83,19.83,0,0,1,.35-4.4A11.94,11.94,0,0,1,5.65,53.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M27.87,48.63c-.38.14-.64.21-.64.21-.12-.4-.67-.14-.87,0a7.15,7.15,0,0,0-.87,1.29A8.59,8.59,0,0,1,22.54,53a19.86,19.86,0,0,0-2.62,1.57s-2.06.25-3.22.42L17,58s4.06-.26,4.57-.83,2.68-2.53,4-4.21c.3-.36.65-1,1.07-1.19a6.75,6.75,0,0,0,1.65-.95c.43-.23.05-.36.37-.52s-.09-.32.08-.71-.28-.49-.08-.67C28.53,48.42,27.89,48.63,27.87,48.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M18.78,54.48a3.41,3.41,0,0,1,.87,2.26,6.49,6.49,0,0,1-.22,2,38,38,0,0,1-6.16.77c-1.39-.16-1.2-1.35-1.94-2.44-1.45-2.12,1.86-2.53,1.86-2.53A18.31,18.31,0,0,0,18.78,54.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M136.66,103.19A300.79,300.79,0,0,0,130,71.36l-.2,0a293.16,293.16,0,0,1,6.63,31.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M134.34,90.8s-1.07-2-6.09-3C128.25,87.81,131.46,92.82,134.34,90.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M134.34,90.8s.15-2.2,4.41-4.78C138.75,86,137.84,91.68,134.34,90.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M133.55,87.15s-.71-2.11-5.62-2.74C127.93,84.41,131,89.07,133.55,87.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M133.55,87.15s-.22-2.21,4.14-4.34C137.69,82.81,136.72,88.09,133.55,87.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M132.79,83.51s-.39-2.28-5.18-2.57C127.61,80.94,130.54,85.36,132.79,83.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M132.79,83.51s-.55-2.28,3.87-4C136.66,79.53,135.63,84.53,132.79,83.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M132.05,79.85s-.15-2.46-4.86-2.54C127.19,77.31,130.09,81.65,132.05,79.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M132.05,79.85s-.83-2.4,3.65-3.75C135.7,76.1,134.59,81,132.05,79.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M131.32,76.11s0-2.57-4.76-2.63C126.56,73.48,129.58,77.89,131.32,76.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M131.32,76.11s-1-2.5,3.56-3.65C134.88,72.46,133.64,77.32,131.32,76.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M130.43,73.32s1-2.45-.9-5.76C129.53,67.56,128.07,69.35,130.43,73.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M136.54,107.7c-1.91-13.56.51-23,8.63-33.81l-.18-.14c-8.16,10.82-10.59,20.35-8.67,34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M135.63,93.81s-.45-2.33-5.3-6.14C130.33,87.67,131.59,94.78,135.63,93.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M135.63,93.81s1.13-2.45,7-2.68C142.67,91.13,139.23,96.19,135.63,93.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M136.44,89.63s.29-2.3-4.34-6C132.1,83.6,132.65,90.32,136.44,89.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M136.44,89.63s1-2.47,6.83-1.91C143.27,87.72,139.41,92.19,136.44,89.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M137.71,85.58s1-2.22-3.41-5.87C134.3,79.71,134.21,86.07,137.71,85.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M137.71,85.58s1-2.55,6.56-1.24C144.27,84.34,140,88.23,137.71,85.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M139.45,81.7s1.59-2-2.59-5.74C136.86,76,136.21,82,139.45,81.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M139.45,81.7s1-2.63,6.33-.67C145.78,81,141.14,84.36,139.45,81.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M141.64,78s2-1.79-1.87-5.75C139.77,72.26,138.58,78.19,141.64,78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M141.64,78s1.15-2.62,6.26-.14C147.9,77.87,142.79,80.65,141.64,78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M143.76,75.49a9,9,0,0,0,4.58-4.39S145.16,70.84,143.76,75.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M136.12,105.18c.91-10.86,4.49-17.82,12.77-24.83l-.12-.13c-8.32,7-11.91,14-12.83,25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M137.88,94.24s.06-1.89-3.06-5.67C134.82,88.57,134.54,94.31,137.88,94.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M137.88,94.24s1.32-1.72,6-.9C143.86,93.34,140.27,96.69,137.88,94.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M139.25,91.12s.64-1.74-2.32-5.41C136.93,85.71,136.16,91,139.25,91.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M139.25,91.12s1.22-1.75,5.69-.33C144.94,90.79,141.12,93.61,139.25,91.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M141,88.19s1.17-1.56-1.63-5.13C139.34,83.06,138.14,88,141,88.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M141,88.19s1.2-1.83,5.35.14C146.32,88.33,142.31,90.63,141,88.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M143,85.46s1.61-1.32-1-4.89C142,80.57,140.42,85.17,143,85.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M143,85.46s1.25-1.87,5.07.55C148.09,86,143.87,87.82,143,85.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M145.39,83s1.89-1-.44-4.77C145,78.19,143,82.59,145.39,83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M145.39,83s1.36-1.84,4.92,1C150.31,83.91,145.82,85.21,145.39,83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M147.49,81.36a7.32,7.32,0,0,0,4.37-2.64S149.42,78,147.49,81.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M134.57,106.42c-.92-10.87-4.5-17.83-12.77-24.83l.12-.14c8.31,7,11.91,14,12.83,25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M132.81,95.47s-.06-1.89,3.06-5.67C135.87,89.8,136.15,95.54,132.81,95.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M132.81,95.47s-1.32-1.72-6-.9C126.82,94.57,130.41,97.92,132.81,95.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M131.44,92.36s-.64-1.75,2.32-5.42C133.76,86.94,134.53,92.26,131.44,92.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M131.44,92.36s-1.23-1.76-5.69-.34C125.75,92,129.57,94.84,131.44,92.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M129.72,89.42s-1.17-1.55,1.63-5.13C131.35,84.29,132.55,89.21,129.72,89.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M129.72,89.42s-1.2-1.82-5.35.14C124.37,89.56,128.38,91.87,129.72,89.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M127.67,86.69s-1.61-1.32,1-4.89C128.67,81.8,130.26,86.4,127.67,86.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M127.67,86.69s-1.26-1.87-5.07.55C122.6,87.24,126.82,89.05,127.67,86.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M125.3,84.2s-1.9-1,.44-4.78C125.74,79.42,127.72,83.82,125.3,84.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M125.3,84.2s-1.37-1.85-4.92.94C120.38,85.14,124.86,86.44,125.3,84.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M123.19,82.6A7.4,7.4,0,0,1,118.82,80S121.27,79.22,123.19,82.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M138.44,107.48h-6.22a2.73,2.73,0,0,1-2.72-2.38l-1.4-10.42h14.46l-1.4,10.42A2.73,2.73,0,0,1,138.44,107.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M129.08,102l.42,3.1a2.73,2.73,0,0,0,2.72,2.38h6.22a2.73,2.73,0,0,0,2.72-2.38l.42-3.1Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 127.18,
    y: 92.18,
    width: 16.34,
    height: 2.4
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsultng);
export default __webpack_public_path__ + "static/media/consultng.09c32679d4ad36efa025b61cbbf983cc.svg";
export { ForwardRef as ReactComponent };